// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let RiskPlanDataKey = function ()
{
    this.Route = null;
    this.InstrumentType = null;
    this.InstrumentId = null;
    this.ContractId = null;
    this.TradableId = null;

}

RiskPlanDataKey.prototype.toString = function ()
{
    let result = "RouteName: " + (this.Route == null ? "DEFAULT" : this.Route) + "; ";

    if (this.InstrumentType !== null)
        result += "InstrumentType: " + this.InstrumentType;

    if (this.InstrumentId !== null)
        result += "InstrumentId: " + this.InstrumentId;

    if (this.ContractId !== null)
        result += "ContractId: " + this.ContractId;

    if (this.TradableId !== null)
        result += "TradableId: " + this.TradableId;

    return result;
}